// Counts clicks through to an event's page (its view count) without sending the link through a
// redirect: links go straight to the page and carry the counter's address in data-count-view, which
// gets a POST in the background. sendBeacon outlives the page change, so no click is lost.

function countClick(event) {
  const link = event.target.closest?.("a[data-count-view]")
  if (!link || (event.type === "auxclick" && event.button !== 1)) return

  const body = new FormData()
  const token = document.querySelector('meta[name="csrf-token"]')?.content
  if (token) body.append("authenticity_token", token)
  navigator.sendBeacon?.(link.dataset.countView, body)
}

// Capture, so the count goes out before anything else handles the click
addEventListener("click", countClick, { capture: true })
// A middle-click opens the page in a new tab, which is a click through too
addEventListener("auxclick", countClick, { capture: true })
